
import {
  computed, defineComponent, onMounted, ref,
} from 'vue';
import { useI18n } from 'vue-i18n';
import CryptoJS from 'crypto-js';
import { UserState } from '@/composables/User';

/**
 * Wraps the legacy Zend interface for V3 shops.
 *
 * Isolated on purpose so the V3 case can be completely replaced later by a
 * dedicated V3 dashboard (planned outside the current P0–P8 scope) without
 * touching the V4/V5 dashboard.
 */
export default defineComponent({
  name: 'BillingV3Frame',

  setup() {
    const { t } = useI18n();
    const iframeRef = ref<HTMLIFrameElement | null>(null);
    const idShop = computed(() => UserState.activeShop?.id ?? 0);

    const iframeSrc = computed(() => {
      const shopId = idShop.value;
      const cryptedKey = CryptoJS
        .SHA1(`remoteplanZn26687S2682MF2ZV4Ag2g9JGbhF686X${shopId}`)
        .toString();
      const base = process.env.VUE_APP_ZEND_URL ?? '';
      return `${base}/advisor/logAsShop/${shopId}/remoteplan/${cryptedKey}`;
    });

    onMounted(() => {
      // No-op : the iframe loads on its own once src is set. Hook kept for
      // future tracking / analytics if needed.
    });

    return {
      t,
      iframeRef,
      iframeSrc,
    };
  },
});
